import { clearBrowserAuth } from "../discord/browserAuth.js";

interface SignOutLinkProps {
  appPath: string;
  /** After clearing; defaults to reloading the page (lands on the sign-in screen). Injectable for tests. */
  onSignedOut?: () => void;
}

/** Browser mode only (caller decides): forget this browser's Discord sign-in. */
export function SignOutLink({ appPath, onSignedOut }: SignOutLinkProps): JSX.Element {
  return (
    <button
      type="button"
      className="signout-link"
      onClick={() => {
        clearBrowserAuth(appPath);
        (onSignedOut ?? (() => window.location.reload()))();
      }}
    >
      Sign out
    </button>
  );
}
